import TenantServiceClient from './TenantServiceClient';

const tenantServiceClient = new TenantServiceClient();

export const getDomains = async (tenant: string): Promise<Record<string, string>> => {
  const tenants = await tenantServiceClient.getTenants();
  const tenantData = tenants.find((t) => t.tenant === tenant);

  if (!tenantData) {
    console.error(`Tenant ${tenant} not found`);
    return {};
  }

  const domainsDictionary: Record<string, string> = {};

  tenantData.sites.forEach((site) => {
    site.locales.supported.forEach((locale) => {
      domainsDictionary[locale] = site.domain;
    });
  });

  return domainsDictionary;
};
